import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/authcontext";

export default function LogoutModal({ setShowLogout }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="logout-modal-backdrop" onClick={() => setShowLogout(false)}>
      <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-icon">⚠</div>
        <h3>Confirm Logout</h3>
        <p>Are you sure you want to log out? You'll need to sign in again to access your account.</p>
        <div className="logout-modal-actions">
          <button className="logout-modal-cancel" onClick={() => setShowLogout(false)}>
            Cancel
          </button>
          <button className="logout-modal-confirm" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
